// BULK REQUEST INTERVIEWS ************************************************************************
// pathname: /v1/resume-operation/job/{jobSlug}/bulk-request-interviews
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';
import { PostBulkRequestInterviewsObject } from '@type/v1-api-types';

/**
 * @description Bulk request interviews for selected applicants of a job.
 *
 * @param jobSlug - the job slug
 * @param locale - the locale
 * @param onSuccess - callback function to be executed on success
 * @param onError - callback function to be executed on error
 *
 * @example
 * const { trigger, isMutating } = useSwrBulkRequestInterviews({ jobSlug: 'job-slug', locale: 'ro' });
 * trigger();
 */
export const useSwrBulkRequestInterviews = (props: {
  jobSlug: string;
  locale?: string;
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const {
    jobSlug,
    locale = 'ro',
    onSuccess,
    onError,
  } = props;

  const {
    data,
    error,
    trigger,
    isMutating,
    reset,
  } = useSwrMutationApi<unknown, PostBulkRequestInterviewsObject>({
    url: `/v1/resume-operation/job/${jobSlug}/bulk-request-interviews`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
      onError: () => {
        if (onError) onError();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  return {
    data,
    error,
    trigger,
    isMutating,
    reset,
  };
};
